import { $api } from "@/services/api";
import {
  UPDATE_ROLE,
  UPDATE_USER,
  UPDATE_LOCALE,
  UPDATE_SHOPPING_TYPE,
  CLEAR_SHOPPING_TYPE,
  CLEAR_ROLE,
  FETCH_PLANTS,
  GET_COST_CENTER_CODES,
  UPDATE_SELECTED_PLANT,
  UPDATE_COST_CENTER_CODES,
  CLEAR_PLANTS,
} from "./actions.type";

const state = {
  plants:
    sessionStorage.getItem("plants") &&
    sessionStorage.getItem("plants") !== "undefined"
      ? JSON.parse(sessionStorage.getItem("plants"))
      : [],
  selectedPlant:
    sessionStorage.getItem("selectedPlant") &&
    sessionStorage.getItem("selectedPlant") !== "undefined"
      ? JSON.parse(sessionStorage.getItem("selectedPlant"))
      : {},
  user:
    sessionStorage.getItem("user") &&
    sessionStorage.getItem("user") !== "undefined"
      ? JSON.parse(sessionStorage.getItem("user")) // if be else then use mock user
      : {},
  role:
    sessionStorage.getItem("role") &&
    sessionStorage.getItem("role") !== "undefined"
      ? sessionStorage.getItem("role")
      : "Requester",
  roles: [],
  shoppingTypeSelected: sessionStorage.getItem("shopping_type"),
  locale: "en",
  shoppingTabSelected: "Recently Purchase",
  costCenterCodes: [],
  // isSpecialUser is now set from backend authentication response
  isSpecialUser: sessionStorage.getItem("isSpecialUser") === "true",
};
const getters = {
  user: (state) => state.user,
  role: (state) => state.role,
  roles: (state) => state.roles,
  locale: (state) => state.locale,
  plants: (state) => state.plants,
  costCenterCodes: (state) => state.costCenterCodes,
  selectedPlant: (state) => state.selectedPlant,
  shoppingTypeSelected: (state) => state.shoppingTypeSelected,
  isSpecialUser: (state) => state.isSpecialUser,
};

const mutations = {
  updateUser(state, user) {
    state.user = user;
    sessionStorage.setItem("user", JSON.stringify(user));
  },
  updatePlants(state, plant) {
    if (state.plants.length) {
      if (!state.plants.find((p) => p.code === plant.code)) {
        state.plants.push(plant);
        sessionStorage.setItem("plants", JSON.stringify(state.plants));
      }
    } else {
      state.plants.push(plant);
      sessionStorage.setItem("plants", JSON.stringify(state.plants));
    }
  },
  [UPDATE_COST_CENTER_CODES](state, costCenter) {
    if (state.costCenterCodes.length) {
      if (!state.costCenterCodes.find((cc) => cc === costCenter)) {
        state.costCenterCodes.push(costCenter);
      }
    } else {
      state.costCenterCodes.push(costCenter);
    }
  },
  updateSelectedPlant(state, selectedPlant) {
    state.selectedPlant = selectedPlant;
  },
  updateRole(state, role) {
    state.role = role;
    sessionStorage.setItem("role", role);
  },
  updateShoppingTypeSelected(state, shoppingType) {
    state.shoppingTypeSelected = shoppingType;
  },
  updateSpecialUser(state, isSpecialUser) {
    state.isSpecialUser = isSpecialUser;
    sessionStorage.setItem("isSpecialUser", isSpecialUser.toString());
  },
  updateLocale(state) {
    if (state.locale == "en") {
      state.locale = "th";
    } else if (state.locale == "th") {
      state.locale = "en";
    }
  },
  clearShoppingType(state) {
    state.shoppingTypeSelected = "";
  },
  clearRole(state) {
    state.role = "";
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  clearRoles(state) {
    state.roles = [];
  },
  [CLEAR_PLANTS](state) {
    state.plants = [];
    sessionStorage.removeItem("plants");
  },
  clearUserState(state) {
    state.shoppingTypeSelected = "";
    state.role = "";
    state.roles = [];
    state.user = {};
    state.selectedPlant = {};
    state.plants = [];
    state.costCenterCodes = [];
    sessionStorage.removeItem("selectedPlant");
    sessionStorage.removeItem("plants");
  },
};
const actions = {
  updateSelectedPlant({ commit }, selectedPlant) {
    commit(UPDATE_SELECTED_PLANT, selectedPlant);
  },
  async [GET_COST_CENTER_CODES]({ commit }, aduser) {
    const responses = await $api.m_zuser_cost_centers.getByQueryString(
      `?aduser=${aduser}&$limit=300`
    );
    if (responses && responses.length) {
      for (const costCenter of responses) {
        commit(UPDATE_COST_CENTER_CODES, costCenter.cost_center_code);
      }
    }
  },
  updateSpecialUser({ commit }, isSpecialUser) {
    commit("updateSpecialUser", isSpecialUser);
  },
  async [FETCH_PLANTS]({ commit }, costCenterCode) {
    const response = await $api.m_cost_center_plants.get({
      code: costCenterCode,
    });
    if (response && response.length) {
      commit("updatePlants", response[0]);
    }
  },
  [UPDATE_SHOPPING_TYPE]({ commit }, shoppingType) {
    commit(UPDATE_SHOPPING_TYPE, shoppingType);
  },
  [UPDATE_ROLE]({ commit }, role) {
    commit(UPDATE_ROLE, role);
  },
  [UPDATE_LOCALE]({ commit }) {
    commit(UPDATE_LOCALE);
  },
  [CLEAR_SHOPPING_TYPE]({ commit }) {
    commit(CLEAR_SHOPPING_TYPE);
  },
  [UPDATE_USER]({ commit }, user) {
    commit(UPDATE_USER, user);
  },
  [CLEAR_ROLE]({ commit }) {
    commit(CLEAR_ROLE);
  },
  setRoles({ commit }, roles) {
    commit("setRoles", roles);
  },
  clearRoles({ commit }) {
    commit("clearRoles");
  },
  clearUserState({ commit }) {
    commit("clearUserState");
  },
};
export default { state, getters, mutations, actions };
